import React from "react";
import priceTable from "./assets/priceTable.jpg";

const Pricing = () => {
  return (
    <div className="welcome-page-2">
      <div className="faq-page-wrapper">
        <header>
          <h1>Gebührenordnung</h1>
        </header>
        <p>
          Nachfolgend findet ihr die EDEKA StartHub-Gebührenordnung. Durch das
          kostenpflichtige Upgrade in den Seller-Plan fällt bei der
          Veröffentlichung des Produktes die Publish-Gebühr an. Wichtig ist
          hierbei, dass diese Gebühr erst erhoben wird sobald euer Produkt auf
          EDEKA StartHub live und bestellbar ist.
        </p>
        <p>
          Die Marketingmaßnahmen sind zusätzlich buchbar sobald das Produkt auf
          EDEKA StartHub veröffentlicht ist.
        </p>
        <p>
          Alle genannten Preise verstehen sich netto zuzüglich der jeweils
          gültigen gesetzlichen Mehrwertsteuer.
        </p>
        <img className="faq-image" src={priceTable} alt="Price Table" />
      </div>
    </div>
  );
};

export default Pricing;
